import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

interface ExportSectionBoxProps {
    title?: string;
    children: ReactNode;
}

const ExportSectionBox = ({ title, children }: ExportSectionBoxProps) => {
    return (
        <Box
            sx={{
                p: 2.5,
                bgcolor: 'grey.50',
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'grey.300',
                display: 'grid',
                gap: 1,
                alignContent: 'start',
            }}
        >
            {title && (
                <Typography
                    variant='h6'
                    sx={{
                        fontWeight: 600,
                        color: 'text.primary',
                    }}
                >
                    {title}
                </Typography>
            )}

            {children}
        </Box>
    );
};

export default ExportSectionBox;

